var _Path, _Path2, _Path3, _Path4, _Path5, _Path6, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgCards = function SvgCards(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#7B3000",
    d: "M29.964 9.22 17.86 6.649a2.25 2.25 0 0 0-2.67 1.733l-4.092 19.257a2.25 2.25 0 0 0 1.733 2.669l12.104 2.573a2.25 2.25 0 0 0 2.669-1.733l4.093-19.258a2.25 2.25 0 0 0-1.733-2.668"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#cards_svg__a)",
    stroke: "#FFE7A1",
    strokeWidth: 0.563,
    d: "M14.906.281H2.531a2.25 2.25 0 0 0-2.25 2.25V22.22a2.25 2.25 0 0 0 2.25 2.25h12.375a2.25 2.25 0 0 0 2.25-2.25V2.53a2.25 2.25 0 0 0-2.25-2.25Z",
    transform: "rotate(12 -11.783 74.552)"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#713000",
    d: "M16.391 3.525 4.384 6.518a2.25 2.25 0 0 0-1.64 2.728l4.764 19.102a2.25 2.25 0 0 0 2.727 1.64l12.008-2.995a2.25 2.25 0 0 0 1.638-2.727L19.12 5.163a2.25 2.25 0 0 0-2.728-1.638"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#cards_svg__b)",
    stroke: "#FFF2AE",
    strokeWidth: 0.563,
    d: "M14.906.281H2.531a2.25 2.25 0 0 0-2.25 2.25V22.22a2.25 2.25 0 0 0 2.25 2.25h12.375a2.25 2.25 0 0 0 2.25-2.25V2.53a2.25 2.25 0 0 0-2.25-2.25Z",
    transform: "rotate(-14 21.983 -3.301)"
  })), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    fill: "#351007",
    d: "M11.612 9.933c-1.366 3.82-3.823 5.592-2.051 8.048.954 1.502 3.137.957 3.82-.952.954 1.501 3.138.957 3.82-.953.412-3.001-2.59-3.412-5.589-6.143m1.633 6.55-.685 4.229 3.275-.817z"
  })), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#351007",
    strokeWidth: 0.787,
    d: "m4.927 11.02.139-4.092 2.59 3.412M5.2 9.793l1.637-.408"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cards_svg__a",
    x1: 0.281,
    x2: 9.849,
    y1: 0.281,
    y2: 22.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cards_svg__b",
    x1: 0.281,
    x2: 0.281,
    y1: 0.281,
    y2: 24.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF5B5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFCC3E"
  })))));
};
export default SvgCards;